<template>
  <div
    class="tw-mb-8 tw-mt-8 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-6"
  >
    <q-icon name="fa-duotone fa-spinner fa-spin-pulse" size="30px" />

    <span v-if="message" class="tw-text-xs">{{ message }}</span>
  </div>
</template>

<script setup>
const props = defineProps({
  message: {
    type: String,
    required: false,
  },
});
</script>
